import script from "./TestView.vue?vue&type=script&setup=true&lang=js"
export * from "./TestView.vue?vue&type=script&setup=true&lang=js"

import "./TestView.vue?vue&type=style&index=0&id=2bb874cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bb874cb"]])

export default __exports__